// extracted by mini-css-extract-plugin
export default {"mobile_layout":"Layout_mobile_layout__2d2qP","pc_layout":"Layout_pc_layout__4U4eM"};